import { Text, FocusTrap } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import CategoriaDeDesafioForm from "../../components/categoria-de-desafio-form";
import { TCategoriaDeDesafioForm } from "../../firestore";

const CategoriaDeDesafioFormModal = ({
  context,
  innerProps,
  id
}: ContextModalProps<{ item: TCategoriaDeDesafioForm }>) => {
  const { item: categoria } = innerProps;
  /**
   * Handle add ignore area success
   */
  function onSuccess() {
    context.closeModal(id);
  }

  return (
    <FocusTrap active={true}>
      <Text fw="bold" mb="md">
        Cadastro de Categoria de Desafio
      </Text>
      <CategoriaDeDesafioForm categoria={categoria} onSuccess={onSuccess} />
    </FocusTrap>
  );
};

export default CategoriaDeDesafioFormModal;
